module.exports = __webpack_public_path__ + "img/IMG_1645_FoamcoreMatted.56c20dde.jpg";